import React from 'react';
import {Section, Button} from '@sail/ui';
import {view, deprecatedCss} from '@sail/engine';

const basic = {
  rendered: (
    <view.div uses={[deprecatedCss`layout: column; gap: $spacing-md;`]}>
      <Section title="Primary value" description="List view insights">
        <Button slot="action">Action</Button>
      </Section>

      <Section title="List view insights">
        <Button type="destructive" slot="action">
          Action
        </Button>
      </Section>

      <Section title="List view insights">
        <Button type="destructive" slot="action">
          Action
        </Button>
        With test content!
      </Section>
    </view.div>
  ),
  source: `<Section title="Primary value" description="List view insights">
  <Button slot="action">Action</Button>
</Section>

<Section title="List view insights">
  <Button type="destructive" slot="action">
    Action
  </Button>
</Section>

<Section title="List view insights">
  <Button type="destructive" slot="action">
    Action
  </Button>
  With test content!
</Section>`,
};

export const SectionExamples = {basic};
